import { fetcher } from "helpers/fetcher";

import {
  TGenerateJobListingBrochureReq,
  TGenerateJobListingBrochureRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const generateJobListingBrochure = async (
  payload?: TGenerateJobListingBrochureReq
) => {
  return await fetcher<
    TGenerateJobListingBrochureRes,
    TGenerateJobListingBrochureReq["data"]
  >(ENDPOINT.CORPORATION.GENERATE_JOB_LISTING_BROCHURE, {
    data: payload?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GENERATE_JOB_LISTING_BROCHURE.version,
      [API_HEADER.CORP_ID]: payload?.idCorp,
    },
  });
};

export const mutationGenerateJobListingBrochure = async (
  payload?: TGenerateJobListingBrochureReq
) => {
  return (await generateJobListingBrochure(payload)).data;
};

mutationGenerateJobListingBrochure._key = (
  payload?: TGenerateJobListingBrochureReq
) => [ENDPOINT.CORPORATION.GENERATE_JOB_LISTING_BROCHURE.url, payload];
